import { Injectable } from '@angular/core';
import { DOCUMENT_VIEWER_MODAL_ID } from '@sb-tools/typescript/constants/nested-modal-ids';
import { AttachmentType } from '@sb-tools/typescript/enums/attachment-type.enum';
import { DocumentViewerModalComponent } from '../components/document-viewer-modal/document-viewer-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ImageAttachment } from '../models/image-attachment.model';
import { DocumentWindowMessageType } from '@sb-document-viewer/enums/document-window-message-type';

@Injectable({ providedIn: 'root' })
export class PreviewService {
    constructor(private bsModalService: BsModalService) {}

    getImageAttachmentList(imageElements: HTMLElement[]): ImageAttachment[] {
        const imageAttachmentModelList: ImageAttachment[] = [];

        imageElements.forEach((image) => {
            imageAttachmentModelList.push({
                attachmentType: AttachmentType.image,
                url: image.getAttribute('src'),
            });
        });

        return imageAttachmentModelList;
    }

    openImagePreview(
        images: ImageAttachment[],
        currentIndex: number,
        isEnablePostMessages?: boolean,
        isEnablePostMessageForWidget?: boolean,
    ): void {
        if (isEnablePostMessageForWidget) {
            window.parent.postMessage(
                {
                    messageType: DocumentWindowMessageType.openPreviewModal,
                    attachment: images[currentIndex],
                },
                '*',
            );
            return;
        }
        const initialState = {
            modalId: DOCUMENT_VIEWER_MODAL_ID,
            attachments: images,
            fileIndex: currentIndex,
        };

        if (isEnablePostMessages) {
            window.parent.postMessage(
                {
                    message: { initialState },
                    isFaqAttachment: true,
                },
                '*',
            );
            return;
        }
        this.bsModalService.show(DocumentViewerModalComponent, {
            initialState,
            class: 'modal-lg modal-document-viewer',
            id: DOCUMENT_VIEWER_MODAL_ID,
        });
    }
}
